// extracted by mini-css-extract-plugin
export default {"Button":"ButtonDark_Button__vEHP5"};